/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { PackageControllerApi } from '../api/packageController.api';
import { switchMap, map } from 'rxjs/operators';
import { PackageControllerData, PackageController } from '../../../interfaces/masters/packagecontroller';

@Injectable()
export class PackageControllerService extends PackageControllerData {

  constructor(private api: PackageControllerApi) {
    super();
  }


  list(): Observable<PackageController[]> {
    return this.api.list();
  }

  getById(url: string): Observable<PackageController>{
      return this.api.getById(url);
  }

  create(url: string, data: PackageController): Observable<PackageController> {
    return this.api.add(url,data);
  }

  update(url: string, data: PackageController): Observable<PackageController> {
    return this.api.update(url,data);
  }

  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
